__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "cnvgArchetype";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "20.3.21", () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9340").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/http.mjs */ 46443))))));
			register("@angular/common", "20.3.21", () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4620").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/common.mjs */ 60316))))));
			register("@angular/core", "20.3.21", () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_10e20").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/core.mjs */ 37580))))));
			register("@angular/router", "20.3.21", () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a220").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2022/router.mjs */ 95072))))));
			register("@azure/msal-angular", "3.1.0", () => (__webpack_require__.e("node_modules_azure_msal-angular_fesm2020_azure-msal-angular_mjs-_6c4a0").then(() => (() => (__webpack_require__(/*! ./node_modules/@azure/msal-angular/fesm2020/azure-msal-angular.mjs */ 8653))))));
			register("@azure/msal-browser", "3.30.0", () => (__webpack_require__.e("node_modules_azure_msal-browser_dist_index_mjs-_29930").then(() => (() => (__webpack_require__(/*! ./node_modules/@azure/msal-browser/dist/index.mjs */ 74102))))));
			register("@oper/common", "1.0.0", () => (__webpack_require__.e("node_modules_oper_common_fesm2022_oper-common_mjs-_f64f1").then(() => (() => (__webpack_require__(/*! ./node_modules/@oper/common/fesm2022/oper-common.mjs */ 75881))))));
			register("rxjs", "7.5.7", () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/dist/esm/index.js */ 80845))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};